import BaseCollection from "nexia_mobile/models/base_collection";
import Mode from "nexia_mobile/models/mode";

export default class ModeCollection extends BaseCollection {
  model = Mode;

  getActiveMode() {
    return this.findWhere({ enabled: true });
  }

  setActiveMode(mode) {
    return mode
      .postCommand("activate")
      .then(
        () => this.fetch(),
        () => this.fetch()
      )
      .then(() => {
        // when the current mode changes, the 'enable' state of each automation
        // can change, so just reload the automations
        this.trigger("reload_automations");
      });
  }
}



// WEBPACK FOOTER //
// ./src/models/mode_collection.js